import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
    const { exchangeSession } = useAuth();
    const navigate = useNavigate();
    const handled = useRef(false);

    useEffect(() => {
        if (handled.current) return;
        handled.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
        const sessionId = params.get("session_id");

        if (!sessionId) {
            toast.error("Sign-in didn't complete");
            navigate("/signin", { replace: true });
            return;
        }

        exchangeSession(sessionId)
            .then(() => {
                toast.success("welcome");
                navigate("/companion", { replace: true });
            })
            .catch(() => {
                toast.error("Sign-in failed");
                navigate("/signin", { replace: true });
            });
    }, [exchangeSession, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <p className="font-heading text-lg tracking-tight text-ink">finishing up…</p>
        </div>
    );
}
